import zhCN from 'antd/locale/zh_CN';
import './App.css';
import { Documents } from './Article/Documents';
import { Example } from './Article/Example';

import { ConfigProvider } from 'antd';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { legacyLogicalPropertiesTransformer, StyleProvider } from '@ant-design/cssinjs';
import { QqOutlined, WechatOutlined } from '@ant-design/icons';
import NiceModal from '@ebay/nice-modal-react';
import { FloatButton, Popover } from 'antd';
import { observer } from 'mobx-react';
import { useEffect, useMemo, useState } from 'react';
import { Article } from './Article';
import { Agreement } from './Article/Agreement';
import Editor from './Article/Documents/Editor/index';
import { summaryStore } from './Article/Documents/store';
import { ErrorBoundary } from './Article/ErrorBoundary/index';
import MyCreation from './Article/MyCreation';
import PPT from './Article/PPT';
import SearchPaper from './Article/SearchPaper';
import telIcon from './assets/tel.png';
import './common/common.scss';
import CompanyIntro from './pages/companyIntro/index';
import ProductIntro from './pages/productIntro/index';
import { loginInstance } from './Service/login';
import { Reduce } from './Article/Reduce/index';
import ExchangeCode from './pages/ExchangeCode/index.jsx';
import UnlockAllChapter from './Article/Documents/UnlockAllChapter';
import EightPieceSet from './Article/EightPieceSet';
import PackageClaim from './pages/PackageClaim';
import Formatter from './pages/formatter/index';
import Distribution from './pages/distribution/index';
import MyPromotion from './pages/distribution/myPromotion/index';
import WithdrawRecords from './pages/distribution/withdrawRecords/index';
import WithdrawInfo from './pages/distribution/withdrawInfo/index';
import lgfbgzh from './assets/lgfbgzh.png';
import lgfbqq from './assets/lgfbqq.png';
import kf from './assets/kf.png';
import EditorV2 from './pages/editorV2/index';
import PptStudio from './pages/pptStudio/index';
import AlipayGo from './pages/writing/alipayGo/index';
import OrderResult from './pages/writing/orderResult/index';
import OrderPreview from './pages/writing/orderPreview/index';
import CaseReader from './pages/writing/caseReader/index';
import { initPageViews } from './analytics/pageViews';
import { useDevice } from './hooks/useDevice';
const router = createBrowserRouter([
    {
        path: '/',
        element: <Article />,
        errorElement: <ErrorBoundary />,
        children: [
            {
                path: '',
                element: <Documents />,
            },
            {
                path: 'example',
                element: <Example />,
            },
            {
                path: '/companyIntro',
                element: <CompanyIntro />,
                errorElement: <ErrorBoundary />,
            },
            { path: '/reduce', element: <Reduce /> },
            {
                path: '/productIntro',
                element: <ProductIntro />,
                errorElement: <ErrorBoundary />,
            },
            {
                path: '/editor',
                element: <Editor />,
                errorElement: <ErrorBoundary />,
            },

            {
                path: '/myCreation',
                element: <MyCreation />,
                errorElement: <ErrorBoundary />,
            },
            {
                path: 'search',
                children: [
                    { path: 'paper', element: <SearchPaper /> },
                    { path: 'ppt', element: <PPT /> },
                ],
            },
            // 答辩PPT（新版 PPT 工作室）
            { path: '/ppt', element: <PptStudio />, errorElement: <ErrorBoundary /> },
            // 新版写作订单：结果页 / 只读预览
            { path: '/order/result', element: <OrderResult />, errorElement: <ErrorBoundary /> },
            { path: '/order/preview', element: <OrderPreview />, errorElement: <ErrorBoundary /> },
            // 微信里打不开支付宝：中转页引导去浏览器打开，系统浏览器里直接跳支付宝
            { path: '/alipayGo', element: <AlipayGo />, errorElement: <ErrorBoundary /> },
            // 首页案例库的范文阅读页（只读）
            { path: '/case/:id', element: <CaseReader />, errorElement: <ErrorBoundary /> },
            // 格式精修
            {
                path: '/formatter',
                element: <Formatter />,
                errorElement: <ErrorBoundary />,
            },
            {
                path: '/distribution',
                element: <Distribution />,
                errorElement: <ErrorBoundary />,
                children: [
                    {
                        path: 'myPromotion',
                        element: <MyPromotion />,
                    },

                    {
                        path: 'withdrawRecords',
                        element: <WithdrawRecords />,
                    },
                    {
                        path: 'withdrawInfo',
                        element: <WithdrawInfo />,
                    },
                ],
            },
        ],
    },
    {
        path: '/editor-v2',
        element: <EditorV2 />,
        errorElement: <ErrorBoundary />,
    },

    { path: '/agreement', element: <Agreement /> },
    { path: '/exchange', element: <ExchangeCode /> },
    { path: '/unlockAllChapter', element: <UnlockAllChapter /> },
    { path: '/eightPieceSet', element: <EightPieceSet /> },
    { path: '/package/claim', element: <PackageClaim /> },
]);
// 行为埋点：路由变化记 page_view，并装上 data-track 点击 / 支付成功监听（只调一次）
initPageViews(router);

const App = observer(() => {
    const [loaded, setLoaded] = useState(false);
    useEffect(() => {
        setLoaded(true);
    }, []);
    // 手机上右下角客服浮钮只留图标，不显示「客服」文字
    const { isMobile } = useDevice();

    const [open, setOpen] = useState(false);

    const hide = () => {
        setOpen(false);
    };

    const show = () => {
        if (!loginInstance.hasLogin) {
            loginInstance.open();
            return;
        }
        setOpen(true);
    };

    const handleOpenChange = (newOpen) => {
        setOpen(newOpen);
    };

    const theme = useMemo(() => {
        // Ultra 版本的主题
        if (summaryStore.useUltra) {
            return {
                cssVar: {
                    key: 'app-container',
                },
                hashed: false,
                token: {
                    colorPrimary: '#FFB300',
                    colorInfoBg: '#fffbe6',
                    colorInfoActive: '#a277ee',
                    colorInfoText: '#a277ee',
                },
            };
        }
        // Normal 版本的主题
        return {
            cssVar: {
                key: 'app-container',
            },
            hashed: false,
            // token: {
            //     colorPrimary: '#00CE72',
            //     colorInfoBg: '#fffbe6',
            //     colorInfoActive: '#a277ee',
            //     colorInfoText: '#a277ee',
            // },
            token: {
                colorPrimary: '#a277ee',
                colorInfoBg: '#fffbe6',
                colorInfoActive: '#a277ee',
                colorInfoText: '#a277ee',
            },
        };
    }, [summaryStore.useUltra]);

    const CustomerServiceButton = () => {
        // 如果是编辑器页面，不展示
        if (window.location.pathname === '/editor' || window.location.pathname === '/editor-v2') {
            return null;
        }
        return (
            <>
                <FloatButton.Group className="lgfb-float-group" shape="square" style={{ bottom: 120, right: 16 }}>
                    <Popover
                        title={
                            <div style={{ textAlign: 'center', fontSize: '16px' }}>
                                灵感风暴官方QQ群
                            </div>
                        }
                        placement="leftBottom"
                        content={<img src={lgfbqq} style={{ width: '180px', margin: '0 auto' }} />}
                    >
                        <FloatButton icon={<QqOutlined />} type="default" />
                    </Popover>
                    <Popover
                        title={
                            <div style={{ textAlign: 'center', fontSize: '16px' }}>关注公众号</div>
                        }
                        placement="leftBottom"
                        content={<img src={lgfbgzh} style={{ width: '180px', margin: '0 auto' }} />}
                    >
                        <FloatButton icon={<WechatOutlined />} type="default" />
                    </Popover>
                </FloatButton.Group>
                <Popover
                    title={<div style={{ textAlign: 'center', fontSize: '16px' }}>联系客服</div>}
                    placement="leftBottom"
                    content={<img src={kf} style={{ width: '180px', margin: '0 auto' }} />}
                >
                    <FloatButton
                        className="customer-service-btn"
                        style={{ bottom: 48, right: 16 }}
                        icon={<img src={telIcon} alt="电话" />}
                        type="primary"
                        shape="square"
                        description={isMobile ? undefined : '客服'}
                    />
                </Popover>
            </>
        );
    };

    return loaded ? (
        <div className="app-container">
            <StyleProvider hashPriority="high" transformers={[legacyLogicalPropertiesTransformer]}>
                <ConfigProvider locale={zhCN} theme={theme}>
                    <NiceModal.Provider>
                        <RouterProvider router={router} />
                        <CustomerServiceButton />
                    </NiceModal.Provider>
                </ConfigProvider>
            </StyleProvider>
        </div>
    ) : (
        ''
    );
});

export default App;
